<template>
    <div>
        
        <a-tree 
            :tree-data="treeData" 
            :show-line="showLine" 
            :show-icon="showIcon"
            :expandedKeys="expandedKeys" 
            :selectedKeys="selectedKeys"
            @expand="handleExpand"
        >

            <template slot="custom" slot-scope="item">
                <span @click="onSelect(item)" :id="item.menucode">{{ item.title }}</span>
                <div class="op_box">
                    <a-icon type="plus" @click="()=> append(item)" title="新建下级" v-if="item.level != 3" />
                    <a-icon type="edit" @click="()=> edit(item)" title="编辑" v-if="item.pid != -1" />
                    <a-popconfirm @confirm="() => remove(item)" v-if="item.pid != -1">
                        <template slot="title">
                            <p>{{ '确认将【' + item.name + '】删除？' }}</p>
                        </template>
                        <a-icon type="delete" title="删除" />
                    </a-popconfirm>
                </div>

            </template>
        </a-tree>
        <p class="tips">
            <a-icon type="alert" />
            <span>点击三级菜单进行文档操作</span>
        </p>
        <treeItem ref="addeditmenu" @onModalHide="handleModalHide"></treeItem>
    </div>
</template>

<script>
import treeItem from './treeitem'

export default {
    components:{
        treeItem
    },
    data() {
        return {
            showLine: true,
            showIcon: false,
            expandedKeys: [],
            selectedKeys:[],
            treeData: [],
            allMenucodes:[],
            searchP: {
                platfromcode: 'open',
            },
            deleteMenucodes:[]
        };
    },
    mounted(){
        this.getAllMenu();
    },
    methods:{
        handleExpand(expandedKeys){
            this.expandedKeys = expandedKeys
        },
        selectNode(mKey){
            this.selectedKeys = [mKey]
        },
        handleModalHide(menuItem) {
            this.getAllMenu(menuItem)
        },

        onSelect(item) {
            if(!item.key){
                return
            }
            if(item.hookconfig == '1' || item.hookconfig == '2' || item.hookconfig == '4'){
                //获得父级菜单名称
                this.selectedKeys = [item.key]
                this.$emit('handleNodeSelect',item.parentTitle,item.parentHookconfig,item);
            }
        },
        //新建下级
        append(item) {
            //一级菜单 可新建 文档菜单 或者 API菜单
            let hookconfigResult = '0';
            if(item.level == 0){
                hookconfigResult = '0'
            }
            //二级菜 文档菜单下只能建文档菜单，API下只能建api
            else if(item.level == 1){
                hookconfigResult = item.hookconfig;
            }
            //三级文章菜单，默认单文档
            else if(item.level == 2 && item.hookconfig == '0'){
                hookconfigResult = '2'
            }
            else if(item.level == 2 && item.hookconfig == '3'){
                hookconfigResult = '1'
            }
            let empty_menu = {
                title: '新建【' + item.name + '】的下级',
                pid: item.id,
                url: '',
                level: parseInt(item.level) + 1,
                platfromcode: item.platfromcode,
                hookconfig:hookconfigResult,
                pmenucode:item.menucode,
                menucode:'',
                name: '',
                ordernum: '',
                id: '',
                icon: ''
            }
            let hookDisabled = false;
            //新建三级菜单，新建一级菜单时可编辑
            hookDisabled = !((empty_menu.level == '3' && item.hookconfig != '3') || empty_menu.level == '1');
            this.$refs.addeditmenu.onModalInit(empty_menu,this.allMenucodes,hookDisabled);
        },
        edit(item) {
            item.title = '编辑【' + item.name + '】';
            this.$refs.addeditmenu.onModalInit(item,this.allMenucodes,true);
        },
        remove(item) {
            //0927 删除文档目录遍历删除文档
            this.deleteMenucodes = [];
            this.searchChildMenucode(item);
            this.deleteMenucodes.forEach(element => {
                this.deleteMenucodeDoc(element)
            });
            this.$store.dispatch({
                type: "ums/deleteMenuConfig",
                params: {id: item.id}
            }).then((res) => {
                if (res.status == '200') {
                    this.getAllMenu();
                    
                }
            });
        },
        searchChildMenucode(treeItem){
            let targetHook = ['1','2','4'];
            if(targetHook.indexOf(treeItem.hookconfig) != -1){
                //是单文档，列表，普通菜单 可能包含文档的类型
                this.deleteMenucodes.push(treeItem.menucode)
            }
            treeItem.children.forEach(element => {
                this.searchChildMenucode(element)
            });
        },
        deleteMenucodeDoc(menucode){
            this.$store.dispatch({
                type: "open/deletedoc",
                params: {menucode: menucode}
            }).then(() => {
                
            });
        },
        //递归树结构
        handleTreeData(treeItem,parentTitle,parentHookconfig,selectedItem) {
            treeItem.title = treeItem.name;
            treeItem.parentTitle = parentTitle;
            treeItem.parentHookconfig = parentHookconfig;
            treeItem.key = treeItem.id;
            treeItem.children = [];
            //当前选中
            if(treeItem.menucode == selectedItem.menucode){
                selectedItem.title = treeItem.name;
                selectedItem.parentTitle = parentTitle;
                selectedItem.parentHookconfig = parentHookconfig;
                selectedItem.key = treeItem.id;
                selectedItem.pmenucode = treeItem.pmenucode;
            }
            
            treeItem.scopedSlots = {title: 'custom'};
            this.allMenucodes.push(treeItem.menucode)
            // console.log(treeItem.scopedSlots)
            if(treeItem.level == 1){
                treeItem.selectable = false;
            }
            treeItem.submenuList.sort(function (a, b) {
                return parseInt(a.ordernum) > parseInt(b.ordernum) ? 1 : -1
            });
            // this.expandedKeys.push(treeItem.key)
            for (let index = 0; index < treeItem.submenuList.length; index++) {
                const r_child = treeItem.submenuList[index];
                r_child.slots = {
                    icon: r_child.icon,
                }
                treeItem.children.push(this.handleTreeData(r_child,treeItem.title,treeItem.hookconfig,selectedItem))

            }
            return treeItem;
        },
        getAllMenu(selectedItem) {
            if(!selectedItem){
                selectedItem = {}
            }
            let that = this;
            that.allMenucodes = [];
            this.$store.dispatch({
                type: "ums/searchMenuConfigTree",
                params: {
                    ...that.searchP,
                    urlparams: false,
                },
                showMsg: false
            },).then((res) => {
                let origin_data = res.data.data
                //排序
                origin_data.sort(function (a, b) {
                    return parseInt(a.ordernum) > parseInt(b.ordernum) ? 1 : -1
                });
                let tempExpandKeys = [];
                that.getSelectedParent(origin_data)
                for (let index = 0; index < origin_data.length; index++) {
                    const element = origin_data[index];
                    element.title = element.name;
                    element.key = element.id;
                    element.scopedSlots = {title: 'custom'};
                    element.selectable = false;
                    tempExpandKeys.push(element.key);
                    that.allMenucodes.push(element.menucode)
                    that.handleTreeData(element,'','',selectedItem)
                }
                that.expandedKeys = that.expandedKeys.concat(tempExpandKeys);
                that.treeData = origin_data;
                that.onSelect(selectedItem)
                // console.log(that.allMenucodes)
            });
        },
        getSelectedParent(data){
            const tMKey = this.mkey;
            if(data.length > 0){
                const menus = data[0].submenuList;
                let parentElement = this.getParentNode(menus,tMKey);
                if(parentElement.submenuList){
                    this.getParentNode(parentElement.submenuList,tMKey);
                }
            }
            
        },
        getParentNode(menus,key){
            let parentElement = {};
            for (let index = 0; index < menus.length; index++) {
                const element = menus[index];
                let strs = JSON.stringify(element.submenuList);
                if(strs.indexOf(key) != -1){
                    parentElement = element
                    break;
                }
            }
            if(parentElement.id){
                this.expandedKeys.push(parentElement.id);
            }
            return parentElement
        }
    },
    props:{
        mkey:String
    },
    watch:{
        'mkey'(newVal){
            if(newVal){
                this.selectNode(newVal);
            }
        }
    }
};
</script>

<style lang="less" scoped>


</style>

<style >
    #logstorelistBox .ant-card-body{
        padding: 0;
        width: 100%;
        height:100%;
        min-width: 1366px;
    }

    #logstorelistBox .ant-tree li span.ant-tree-switcher{
        display: none;
    }

    #logstorelistBox .ant-tree-switcher-noop{
        visibility: hidden;
    }
    

    .op_box{
        position:absolute;
        right: 6px;
        top: 7px;
    }

    .op_box i{
        padding:0 4px;
    }

    .tips{
        margin: 20px;
        text-align: center;
    }

    .tips i{
        font-size: 16px;
        color: #1890ff;
        margin: 2px 10px 0 0;
    }

</style>
